import {EnrollNedbGrade} from './enroll-nedb-grade';
import {ParticipateInRanging} from '../../../../common/enums/participate-in-ranging.enum';

export class EnrollEntranceInfo {
  learn_lang: number = null;
  academic_degree: number = null;
  payment_form: number = null;
  department_id = 1;
  grant_type: number = null;
  learn_form: number = null;
  speciality: number = null;
  qualification: number = null;
  hostel: number = null;
  hostel_need_cause = '';
  reg_date: Date = new Date();
  specialExamType: number;
  specialExam: number;
  workQualification: boolean;
  submissionDate: Date;
  grades: EnrollNedbGrade[];
  inRanging = ParticipateInRanging.NOT_DETERMINED;
  inRangingSavedDate: boolean;
  specialExamProvided = false;
  mustBeDecidedByCommission = false;
}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/model/enroll-entrance-info.ts